import {useAsync} from '@freckle/educator-entities/ts/common/hooks/use-async'
import {useSchools} from '@freckle/educator-entities/ts/common/hooks/use-schools'
import {WithResources} from '@freckle/school/ts/common/components/with-resources'
import RosterApi from '@freckle/school/ts/common/helpers/api/rostering'
import {fetchSummary} from '@freckle/school/ts/common/models/summary'
import {useSchoolAdmin} from '@freckle/school/ts/hooks/use-school-admin'
import {
  fetchTeacherTableRows,
  nonIdpTeachersFilter,
} from '@freckle/school/ts/manage-teachers/api-helpers/api-teacher-table'
import {CleanUpRosterContainer} from './clean-up-roster-container'

export default function CleanUpRosterHandler() {
  const schools = useSchools()
  const schoolAdmin = useSchoolAdmin()

  const schoolIds =
    schools.status === 'success' ? Array.from(new Set(schools.data.map(school => school.id))) : null

  const summary = useAsync(
    () => fetchSummary(schoolAdmin.data!.id, schoolIds!),
    'fetchSummary',
    [schoolIds],
    {
      enabled: !!schoolIds && !!schoolAdmin.data,
    },
  )

  const tableRows = useAsync(
    () =>
      fetchTeacherTableRows(schoolIds!, {
        limit: 1,
        additionalFilters: nonIdpTeachersFilter,
      }),
    'fetchTeacherTableRows',
    [schoolIds, {limit: 1, additionalFilters: nonIdpTeachersFilter}],
    {enabled: !!schoolIds},
  )

  const initialUnmanagedCourses = useAsync(
    () => RosterApi.findUnmanagedCourses(schoolIds!),
    'RosterApi.findUnmanagedCourses',
    [schoolIds],
    {enabled: !!schoolIds},
  )

  return (
    <WithResources
      resources={{
        schools,
        summary,
        initialUnmanagedCourses,
        tableRows,
        schoolAdmin,
      }}
      render={({schools, summary, initialUnmanagedCourses, tableRows, schoolAdmin}) => (
        <CleanUpRosterContainer
          schools={schools}
          initialSummary={summary}
          numSelfRosteredTeachers={tableRows.totalCount}
          initialUnmanagedCourses={initialUnmanagedCourses}
          schoolAdmin={schoolAdmin}
        />
      )}
    />
  )
}
